import { useCallback } from "react";
import { isEmpty } from "lodash";
import { useToastSaurus } from "./toast-saurus";
import { EnumContratoConfig } from "../../../model/enums/enum-contrato-config";
import { useKdsToken } from "./kds-token";
import { useGetConfigContrato } from "../../../data/api/gestao/contrato/get-contrato-configuracao";
import { ContratoConfigCompletoModel } from "../../../model/api/gestao/master/contrato-completo-config";
import { KdsStorageKeys, useKdsStorage } from "./kds-storage";
import { ConfigEmpresaModel } from "../../../model/api/gestao/master/config-empresa-model";

export const useContratoAtual = () => {
    const { getRegistro } = useKdsStorage()

    const { getConfigContrato, carregando: carregandoConfigContrato } =
        useGetConfigContrato();
    const { showToast } = useToastSaurus()
    const { getPessoaUsuario } = useKdsToken();

    const carregando =
        carregandoConfigContrato

    const getConfigCompleto = useCallback((): ContratoConfigCompletoModel | undefined => {
        const ret = getRegistro(KdsStorageKeys.ConfigContrato, false) as ContratoConfigCompletoModel;
        if (isEmpty(ret))
            return undefined;

        return ret;
    }, [getRegistro])


    const getContratoConfig = useCallback(
        async () => {
            try {
                const res = await getConfigContrato(getPessoaUsuario().pessoa?.contratoId || '');

                if (res.erro) {
                    throw res.erro;
                }

                const data = res.resultado?.data as ConfigEmpresaModel[];

                return data
            } catch (e: any) {
                showToast('error', e.message)
            }
        },
        [getConfigContrato, getPessoaUsuario, showToast],
    );

    const getConfigByCod = useCallback((cod: EnumContratoConfig): string | undefined => {
        const contratoAtual = getConfigCompleto();

        if (isEmpty(contratoAtual))
            return undefined;
        if (isEmpty(contratoAtual))
            return undefined;

        const contratoConfig =
            contratoAtual
                ?.configuracoes
                .find(x => x.cod === cod)
                ?.vConfig

        if (isEmpty(contratoConfig))
            return undefined

        return contratoConfig
    }, [getConfigCompleto])

    return {
        carregando,
        getConfigByCod,
        getConfigCompleto,
        getConfigContrato,
        getContratoConfig
    }
}